/* ----- code generated do not modify ----- */
var components_combo_box_locale2 = {
  "buttonLabel": "Zobrazit doporu\u010Den\xED",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "K dispozici ".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "je ".concat(formatter.number(args.optionCount), " mo\u017Enost");
      },
      other: function other() {
        return "jsou/je ".concat(formatter.number(args.optionCount), " mo\u017Enosti/-\xED");
      }
    }), ".");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      "true": function _true() {
        return "Zadan\xE1 skupina \u201E".concat(args.groupTitle, "\u201C ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "s ".concat(formatter.number(args.groupCount), " mo\u017Enost\xED");
          },
          other: function other() {
            return "se ".concat(formatter.number(args.groupCount), " mo\u017Enostmi");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      "true": " (vybr\xE1no)",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "N\xE1vrhy",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", vybr\xE1no");
  }
};

export { components_combo_box_locale2 as default };
//# sourceMappingURL=cs-CZ.esm.js.map
